var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resolution-ui-wrapper"},[_c('v-alert',{attrs:{"type":"error"}},[_vm._v(" There was an error determining how to complete this step. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }